<template>
	<div class="study">
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="practice bg_gray">
			<div class="w1200 flex">
				<div class="practice_l bg_white radius8">
					<div class="test_nav">
						<router-link :to="{ path: '/test_list', query: { type: item }}" v-for="(item,index) in testNav" :key="index" class="test_nav_list radius8 cl_white f26px flex">
							<span>{{item}}</span>
							<img src="../../../static/more_white.png" />
						</router-link>
					</div>
					<!-- <div class="increase">
						<div class="practice_title f20px cl_dark">提分计划</div>
						<div class="increase_cont">
							<router-link to="" v-for="item in increase" :key="item.id" class="increase_list">
								
							</router-link>
						</div>
					</div> -->
					<div class="new_test mat20">
						<div class="practice_title f20px cl_dark">最新发布</div>
						<div class="new_test_nav cl_gray tc">
							<span class="new_test_nav_list bg_gray" v-for="item in newTestNav" :key="item.subjectId" :class="{'on':item.subjectId==testCur}" @click="navCheck(item.subjectId)">{{item.subjectName}}</span>
						</div>
						<div class="new_test_cont flex mat10">
							<div class="new_test_list radius8 mab20" v-for="item in newTest" :key="item.id">
								<div class="new_test_list_show">
									<div class="new_test_list_top flex">
										<h3 class="f18px">{{item.paperName}}</h3>
										<p class="f16px cl_violet">{{item.number}}题</p>
									</div>
									<div class="new_test_list_btm cl_gray">
										<!-- <p class="flex mar10"><img src="../../../static/icon_time.png" class="mar5" /><span>更新于{{item.add_time}}</span></p> -->
										<p class="flex mal10"><img src="../../../static/icon_person.png" class="mar5" /><span>{{item.read_count==null? '0':item.read_count}}</span></p>
									</div>
								</div>
								<div class="new_test_list_hide radius8">
									<router-link :to="{ path: '/practice_test', query: { id: item.id }}" class="f12px cl_white flex"><img src="../../../static/icon_practice.png" class="mar5" /><span>开始练习</span></router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="practice_r bg_white radius8">
					<div class="practice_title f20px cl_dark">我的题库</div>
					<img src="../../../static/wrong.png" class="block practice_r_img mat20 mab20" />
					<div class="practice_r_cont f16px">
						<router-link to="/wrong" class="practice_r_list flex">
							<div class="practice_r_list_l">
								<img src="../../../static/wrong_topic.png" class="mar5" />
								<span>错题本</span>
							</div>
							<i class="cl_yel">{{myInfo.user_question_err_num}}</i>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'test_index',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: 2,
				myInfo: {},
				public: {},
				testNav: [],
				testCur: 1,
				testName: "",
				newTestNav: [],
				newTest: [],
			}
		},
		mounted() {
			this.getType();
			this.getSubject();
		},
		created() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//类型
			getType () {
				this.$get("/api/funlearning/get_paper_type_data",{})
				.then(res => {
					this.testNav = res.data;
				});
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.newTestNav = res.data;
					this.testCur = this.newTestNav[0].subjectId;
					this.testName = this.newTestNav[0].subjectName;
					this.getTest();
				});
			},
			//试卷
			getTest () {
				this.$get("/api/funlearning/get_new_papers_data",{
					parse_name: localStorage.getItem("pharseName"),
					subject_name: this.testName,
				})
				.then(res => {
					this.newTest = res.data;
				});
			},
			navCheck (e) {
				this.testCur = e;
				for (let i = 0; i < this.newTestNav.length; i++) {
					if (this.testCur == this.newTestNav[i].subjectId) {
						this.testName = this.newTestNav[i].subjectName;
					}
				}
				this.getTest();
			},
		},
	}
</script>

<style>
</style>
